import { BgColors, BgPositionsDesign, BgSizeDesign } from "types/generic/types";

interface GetBackgroundClassNamesProps {
  backgroundColor?: BgColors;
  backgroundImage?: string;
  backgroundPosition?: BgPositionsDesign;
  backgroundSize?: BgSizeDesign;
}

export const getBackgroundClassNames = ({
  backgroundColor,
  backgroundPosition,
  backgroundSize,
}: GetBackgroundClassNamesProps) => ({
  [`bg--${backgroundColor}`]: !!backgroundColor,
  [`bg-position--${backgroundPosition}`]: !!backgroundPosition,
  [`bg-size--${backgroundSize}`]: !!backgroundSize,
});
